"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errorPagesTypes_1 = require("./errorPagesTypes");
function errorPagesReducer(state = {}, action) {
    if (action.type === errorPagesTypes_1.SetErrorType.SET_ERROR)
        return Object.assign({}, action.payload);
    return state;
}
exports.default = errorPagesReducer;
